 // React Component (or JSX)

 import React from 'react';
 import './App.css'; // Assuming you have a CSS file for styles
 
 const MichaelTarlton_Twitter = () => {
   return (
        <>
      
<div className="css-175oi2r r-1iusvr4 r-16y2uox">
  <div className="css-175oi2r r-1awozwy r-18u37iz r-1wtj0ep">
    <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
      <div className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l">
        <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
          <a href="https://x.com/MichaeTa" role="link" className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
            <div className="css-175oi2r r-1awozwy r-18u37iz r-dnmrzs">
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-1udh08x r-3s2u2q" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Michael Tarlton</span>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-9iso6" style={{ textOverflow: 'unset' }}></span>
                </span>
              </div>
              <div dir="ltr" className="css-146c3p1 r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-xoduu5 r-18u37iz r-1q142lx" style={{ textOverflow: 'unset', color: 'rgb(15, 20, 25)' }}>
                <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1awozwy r-xoduu5" style={{ textOverflow: 'unset' }}>
                  {/* Updated SVG size */}
                  <svg viewBox="0 0 22 22" aria-label="Verified account" role="img" className="r-4qtqp9 r-yyyyoo r-1xvli5t r-bnwqim r-lrvibr r-m6rgpd r-1cvl2hr r-f9ja8p r-og9te1 r-3t4u6i" data-testid="icon-verified" style={{ width: '16px', height: '16px' }}>
                    <g><path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path></g>
                  </svg>
                </span>
              </div>
            </div>
          </a>
        </div>
        <div className="css-175oi2r r-1awozwy r-18u37iz r-1wbh5a2">
          <div className="css-175oi2r r-1wbh5a2 r-dnmrzs">
            <a href="https://x.com/MichaeTa" role="link" 
            // tabIndex="-1" 
            className="css-175oi2r r-1wbh5a2 r-dnmrzs r-1ny4l3l r-1loqt21">
              <div className="css-175oi2r">
                <div dir="ltr" className="css-146c3p1 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-37j5jr r-a023e6 r-rjixqe r-16dba41 r-18u37iz r-1wvb978" style={{ textOverflow: 'unset', color: 'rgb(83, 100, 113)' }}>
                  <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>@MichaeTa</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="css-175oi2r r-1cwvpvk" style={{ minWidth: '0px' }}>
      <button aria-describedby="id__wcoj9flt6h" aria-label="Follow @MichaeTa" role="button" className="css-175oi2r r-sdzlij r-1phboty r-rs99b7 r-lrvibr r-15ysp7h r-4wgw6l r-3pj75a r-1loqt21 r-o7ynqc r-6416eg r-1ny4l3l" data-testid="731230526778970112-follow" type="button" style={{ backgroundColor: 'rgb(15, 20, 25)', borderColor: 'rgba(0, 0, 0, 0)' }}>
        <div dir="ltr" className="css-146c3p1 r-bcqeeo r-qvutc0 r-37j5jr r-q4m81j r-a023e6 r-rjixqe r-b88u0q r-1awozwy r-6koalj r-18u37iz r-16y2uox r-1777fci" style={{ textOverflow: 'unset', color: 'rgb(255, 255, 255)' }}>
          <span className="css-1jxf684 r-dnmrzs r-1udh08x r-3s2u2q r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3 r-1b43r93 r-1cwl3u0" style={{ textOverflow: 'unset' }}>
            <span className="css-1jxf684 r-bcqeeo r-1ttztb7 r-qvutc0 r-poiln3" style={{ textOverflow: 'unset' }}>Follow</span>
          </span>
        </div>
      </button>
    </div>
    <div dir="auto" className="css-146c3p1" id="id__wcoj9flt6h" style={{ display: 'none' }}>
      Click to Follow MichaeTa
    </div>
  </div>
</div>
        </>
        );
      };
      
export default MichaelTarlton_Twitter;
 